<template>
  <ag-grid-vue
    class="ag-theme-alpine"
    style="width: 100%; height: 76vh"
    :columnDefs="columnDefs"
    :suppressPropertyNamesCheck="true"
    :rowData="rowData"
    @grid-ready="onGridReady"
    :enableRangeSelection="true"
    :sideBar="sideBar"
    :masterDetail="MasterDetail"
    :keepDetailRowsCount="1"
    :groupDefaultExpanded="1"
    :suppressAggFuncInHeader="true"
    @row-group-opened="rowGroupOpened"
    :detailCellRendererParams="detailCellRendererParams"
    :detailRowHeight="500"
    :embedFullWidthRows="false"
    :rowClassRules="RowClassRules"
    :pagination="false"
    :paginationPageSize="false"
    :suppressColumnVirtualisation="true"
    @column-visible="autoSizeColumns()"
    :getContextMenuItems="getContextMenuItems"
  >
  </ag-grid-vue>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import 'ag-grid-enterprise';
import CurrencyCellRenderer from './CellRenderer/CurrencyCellRenderer';
import PercentageCellRenderer from './CellRenderer/PercentageCellRenderer';
import ExportPopup from './ExportPopup.vue';
import DetailColumnToolPanel from './DetailColumnToolPanel';
import EventBus from '@/services/EventBus.js'
import IncludeRegardlessOfValuesCellRenderer from './CellRenderer/IncludeRegardlessOfValuesCellRenderer';

export default {
  name: "Dashboard-tap",
  components: {
    AgGridVue,
    currencyCellRenderer: CurrencyCellRenderer,
    percentageCellRenderer: PercentageCellRenderer,
    ExportPopup,
    DetailColumnToolPanel,
    includeRegardlessOfValuesCellRenderer: IncludeRegardlessOfValuesCellRenderer,
  },
  props: {
    ColumnDefs: null,
    RowData: null,
    SideBar: null,
    MasterDetail: null,
    DetailCellRendererParams: null,
    ShowLoadingOverlay: {default: false},
    Level: null,
    RowClassRules: null
  },
  data() {
    return {
      columnDefs: null,
      detailCellRendererParams: null,
      gridApi: null,
      gridColumnApi: null,
      isLoading: false,
      rowData: [],
      sideBar: null,
      selectedRows: null,
      selectedModel: null,

      firstRowSurveyInstances: null,
    }
  },
  created() {
    EventBus.$on('MountGridData', () => {
      this.mountData();
    });
    // listen to event from DetailColumnToolPanel to show/hide level 2 columns
    EventBus.$on('DetailColumnHide', (field, hide) => {
      var def = this.detailCellRendererParams?.detailGridOptions?.columnDefs?.find(def => def.field === field);
      if(def) {
        def.hide = hide;
        this.gridApi.onGroupExpandedOrCollapsed();
      }
    });
    EventBus.$on('DetailColumnHideAll', hide => {
      this.detailCellRendererParams.detailGridOptions.columnDefs.forEach(def => def.hide = hide);
    });
    EventBus.$on('autoSizeColumns', () => {
      this.autoSizeColumns();
    });
  },
  beforeMount() {
  },
  watch: {
    ShowLoadingOverlay(newVal, oldVal) {
      if(newVal) {
        this.gridApi.showLoadingOverlay();
      } else {
        setTimeout(() => {
          this.collapseAll();
          this.autoSizeColumns();
          this.gridApi.hideOverlay();
        }, 200);
      }
    }
  },
  methods: {
    mountData() {
      this.columnDefs = this.ColumnDefs;
      this.gridApi.setColumnDefs(this.columnDefs);
      this.rowData = this.RowData;
      this.sideBar = this.SideBar;
      this.detailCellRendererParams = this.DetailCellRendererParams;
    },
    collapseAll() {
      // collapse all rows
      this.gridApi.forEachNode(function (node) {
        node.expanded = false;
      });
      this.gridApi.onGroupExpandedOrCollapsed();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onRowClicked(params) {
      // collapse other rows on selectionchange
      // this.gridApi.forEachNode(node => {
      //   if(node != params.node) node.expanded = false;
      // });
      // params.node.expanded = !params.node.expanded;
      // this.gridApi.onGroupExpandedOrCollapsed();

      this.autoSizeDetailColumns();
    },
    rowGroupOpened(params) {
      this.autoSizeDetailColumns();
    },
    autoSizeDetailColumns() {
      var colIds = [];

      this.gridApi.forEachDetailGridInfo((detailGridApi) => {
        if(detailGridApi) {
          detailGridApi.columnApi.getColumns().forEach(col => {
            colIds.push(col.getId());
          });
          detailGridApi.columnApi.autoSizeColumns(colIds);
        }
      });
    },
    autoSizeColumns() {
      var colIds = [];
      this.gridColumnApi.getColumns().forEach(col => {
        colIds.push(col.getId());
      })

      this.gridColumnApi.autoSizeColumns(colIds);
    },
    getContextMenuItems(params) {
      var result = ['copy', 'copyWithHeaders'];
      return result;
    }
  },
}
</script>

<style lang="scss">
  .rcr-green-row {
    background-color: rgb(154, 204, 154) !important;
  }
  .rcr-red-row {
    background-color: rgb(196, 142, 142) !important;
  }
  .rcr-light-green-row {
    background-color: rgb(187, 241, 187) !important;
  }
</style>
